import { React, useState, useEffect } from "react";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../../src/Pages/styledElements";
import { Button, Form, Input, Select, Col, Row, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { GlobalSet } from "../../pageStyled";
import { Group } from "antd/lib/avatar";
const { Option } = Select;
const ViewMergeDrawer = (props) => {
  const [form] = Form.useForm();

  const seperateOrdersHandler = () => {
    props.updateTable();
  };
  const deckleWidthUnitData = ["cm", "mm"];
  const [selectedUnit, setSelectedUnit] = useState(deckleWidthUnitData[0]);
  const deckleMatchTab = [
    { label: "Standard", value: "standard" },
    { label: "Optional", value: "optional" },
  ];
  useEffect(() => {
    form.setFieldsValue({
      core_id: props?.selectedGroup?.core_id,
      reel_od: props?.selectedGroup?.reel_od,
    });
  }, []);
  return (
    <RightDrawerSidebar
      title={`View Merged Orders`}
      visible={props.visible}
      onClose={() => {
        props.onCloseMergeOrderDrawer();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Merged Orders Product Name</h5>
                    <p>Final product to be produced after merging</p>
                  </div>
                  <Form.Item
                    name="Merge order product name"
                    className="dBlock"
                    initialValue={`${props.currentGroup?.product?.code} - ${props.currentGroup?.product?.name}`}
                  >
                    <Input disabled placeholder="Product" />
                  </Form.Item>
                </div>
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Rewinder Dimensions</h5>
                    <p>The outer diameter of the reel and rewinder core</p>
                  </div>
                  <Col span={24}>
                    <Row className="centerAlign  justifyCSBetween">
                      <Col span={11} className="blockBreak">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <span>Core OD</span>
                          <Form.Item
                            // label="Core OD"
                            name="core_id"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={props?.currentGroup?.core_id}
                          >
                            <Input disabled placeholder="For Core OD" />
                          </Form.Item>
                        </div>
                      </Col>
                      {/* <Col span={8} className="blockBreak">
                        <div className="boxFormType">
                          <Form.Item
                            label="Reel OD"
                            name="reel_od"
                            rules={[{ required: true }]}
                            className="dBlock"
                            initialValue={props?.currentGroup?.reel_od}
                          >
                            <Input disabled placeholder="For Reel OD" />
                          </Form.Item>
                        </div>
                      </Col> */}
                      <Col
                        span={11}
                        className="blockBreak"
                        style={{ display: "flex" }}
                      >
                        {/* <label className="labelSel">Unit</label> */}
                        <div className="boxFormType unitSelect">
                          <span>Unit</span>
                          <Form.Item
                            // label="Unit"
                            className="dBlock"
                            name="unit"
                            initialValue={props?.units?.core_id}
                          >
                            <Select
                              label="Unit"
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              className="dBlock"
                              disabled
                            >
                              {deckleWidthUnitData.map((deckleWidth) => (
                                <Option key={deckleWidth} value={deckleWidth}>
                                  {deckleWidth}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Merged Orders</h5>
                    <p>Orders merged in this group to produce together</p>
                  </div>
                  <div className="prod-reelset">
                    {props.currentGroup?.merged_groups?.map((group) => {
                      return (
                        <ProductionSet>
                          <div className="prodset-header">
                            <GlobalSet>
                              <div className="checklist-address">
                                <div className="prodleft-header">
                                  <h4>{group.product_spec}</h4>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      paddingLeft: "0px",
                                    }}
                                  >
                                    {/* <span style={{ paddingRight: "20px" }}>
                                      Qty: {`${group.quantity} Reels`}
                                    </span> */}
                                    <span>
                                      Weight:
                                      {`${group.weight.toFixed(3)} ${props?.units?.weight}`}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </GlobalSet>
                          </div>
                          <div className="prodset-body">
                            <div className="prodset-dt">
                              <Col span={24}>
                                <Row className="centerAlign  justifyCSBetween">
                                  {/* <Col span={6}>
                                    <h5>Reel OD:</h5>
                                  </Col>
                                  <Col span={6}>
                                    <p>{`${group.reel_od} CM`}</p>
                                  </Col> */}
                                  <Col span={6}>
                                    <h5>Core OD:</h5>
                                  </Col>
                                  <Col span={18}>
                                    {console.log(props)}
                                    <p>{`${group.core_id} ${props?.units?.core_id}`}</p>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                            <div className="prodset-dt">
                              <Col span={24}>
                                <Row className="centerAlign  justifyCSBetween">
                                  <Col span={6}>
                                    <h5>Orders:</h5>
                                  </Col>
                                  <Col span={6}>
                                    <p>{`${group.orders.length}`}</p>
                                  </Col>
                                  <Col span={8}>
                                    <h5>Priority Orders:</h5>
                                  </Col>
                                  <Col span={4}>
                                    <p>{`${group.priority_orders}`}</p>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                            <div
                              className="drawerField"
                              style={{ padding: "10px 0 0px" }}
                            >
                              <h5>Deckle Match Fulfillment</h5>
                              <div
                                className=" switchRadio twoSwitch"
                                style={{
                                  justifyContent: "center",
                                  display: "flex",
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <Radio.Group
                                  // disabled={validateData.type ? false : true}
                                  options={deckleMatchTab}
                                  optionType="button"
                                  buttonStyle="solid"
                                  value={
                                    props.currentGroup.optional_groups.includes(
                                      group.id
                                    )
                                      ? "optional"
                                      : "standard"
                                  }
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          {group.merged && (
                            <div className="prodset-footer">
                              <label>Status</label>
                              <span dataset="Produced">Merged Orders</span>
                            </div>
                          )}
                        </ProductionSet>
                      );
                    })}
                  </div>
                </div>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                      onClick={seperateOrdersHandler}
                    >
                      <Iconmoon icon="export" size={16} color="#ffffff" />
                      Separate Orders{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default ViewMergeDrawer;
